import { PRODUCTS_PER_PAGE } from "../../consts";
export function getOffset(page) {
  return (page - 1) * PRODUCTS_PER_PAGE;
}
export function getPageTotal(total) {
  return Math.ceil(total / PRODUCTS_PER_PAGE);
}
export function getSellerPageUrl(sellerSlug) {
  return "/seller/".concat(sellerSlug, "/products.html");
}